define('views/parts/modal/login-with-zoom-modal',[
    'mustache',
    'services/i18n',
    'services/platform.service',
    'views/parts/modal/modal',
    'text!templates/parts/modal/login-with-zoom-modal.html',
], function(
    Mustache, i18n, PlatformService, VModal, TLoginWithZoomModal
) {

    var VLoginWithZoomModal = VModal.extend({
        template: TLoginWithZoomModal,

        modal: function() {
            return {
                title: i18n.t('conversation:login-with-zoom-modal-title'),
                size: 'medium'
            };
        },

        buttons: function() {
            return {
                confirm: {
                    label: i18n.t("Ok"),
                    callback: this.onConfirm,
                },
            }
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                redirect_uri: window.env.APP_DOMAIN,
                client_id: window.env.ZOOM_CLIENT_ID,
                isMobile: PlatformService.isMobile()
            })));

            this.renderModal();

            return this;
        },


    });

    return VLoginWithZoomModal;
});

